import moment from "moment";

const convertTime = (time) => {
  let convertedTime = moment(time).format("DD/MM/YYYY");
  if (moment().isSame(moment(time), "day")) {
    convertedTime = moment(time).format("hh:mm");
  }
  return convertedTime;
};

export default convertTime;
